import React from 'react';
import { render, screen } from '@testing-library/react';
import Logo from './Logo';

describe('Logo', () => {
  it('renders an image with alt text', () => {
    render(<Logo />);
    expect(screen.getByAltText('Landing.Jobs')).toBeInTheDocument();
  });

  it('renders with default props', () => {
    render(<Logo />);
    const img = screen.getByAltText('Landing.Jobs');
    expect(img.tagName).toBe('IMG');
    expect(img).toHaveAttribute('src');
  });

  it('renders with custom version, intensity, and type', () => {
    render(<Logo version="company" intensity="light" type="horizontal" />);
    expect(screen.getByAltText('Landing.Jobs')).toBeInTheDocument();
  });

  it('renders talent solo logo', () => {
    render(<Logo version="talent" type="solo" />);
    expect(screen.getByAltText('Landing.Jobs')).toBeInTheDocument();
  });

  it('renders neutral dark vertical logo', () => {
    render(<Logo version="neutral" intensity="dark" type="vertical" />);
    expect(screen.getByAltText('Landing.Jobs')).toBeInTheDocument();
  });

  it('returns null for invalid combination', () => {
    const { container } = render(<Logo version="company" intensity="dark" type="solo" />);
    expect(container.firstChild).toBeNull();
  });

  it('applies custom className', () => {
    render(<Logo className="custom" />);
    const img = screen.getByAltText('Landing.Jobs');
    expect(img).toHaveClass('custom');
  });

  describe('accessibility', () => {
    it('has role="img"', () => {
      render(<Logo />);
      expect(screen.getByRole('img')).toBeInTheDocument();
    });

    it('has default alt text', () => {
      render(<Logo />);
      expect(screen.getByRole('img')).toHaveAttribute('alt', 'Landing.Jobs');
    });

    it('supports custom alt text', () => {
      render(<Logo alt="Company logo" />);
      expect(screen.getByAltText('Company logo')).toBeInTheDocument();
    });

    it('renders as decorative with empty alt and aria-hidden', () => {
      const { container } = render(<Logo decorative />);
      const img = container.querySelector('img');
      expect(img).toHaveAttribute('alt', '');
      expect(img).toHaveAttribute('aria-hidden', 'true');
    });

    it('does not set aria-hidden when not decorative', () => {
      const { container } = render(<Logo />);
      const img = container.querySelector('img');
      expect(img).not.toHaveAttribute('aria-hidden');
    });
  });
});
